import React, { Component } from 'react';
export default class GoogleMap extends Component {
  constructor(props) {
    super(props);
    this.onScriptLoad = this.onScriptLoad.bind(this);
  }
  onScriptLoad() {
    const map = new window.google.maps.Map(document.getElementById(this.props.id), this.props.options);
    this.props.onMapLoad(map);
  }
  async componentDidMount() {
    const markercluster = document.createElement("script");
    markercluster.src = `https://s3.amazonaws.com/${process.env.REACT_APP_DOMAIN_NAME.toLowerCase()}/markercluster.js`;
    markercluster.async = true;
    markercluster.id = "googleMarkerCluster";
    document.body.appendChild(markercluster);
    markercluster.addEventListener('load', () => {
      const googlemaps = document.createElement("script");
      googlemaps.src = `https://maps.google.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}`;
      googlemaps.async = true;
      googlemaps.id = "googleMaps";
      document.body.appendChild(googlemaps);
      // Below is important.
      // We cannot access Google Maps until it's finished loading
      googlemaps.addEventListener('load', () => {
        this.onScriptLoad();
      });
    });
  }
  render() {return <div style={{width:'100%',height:500,maxWidth:1140,border:'solid 1px #000000'}} id={this.props.id}/>}
}


// WEBPACK FOOTER //
// ./src/components/GoogleMap.js